<template>
  <div>
    <input type="hidden" :value="this.bx_mac = regionMeter.bx_mac">
    <input type="hidden" :value="this.request_date = requestDate">
    <div style="overflow-y: hidden">
      <table class="table table-bordered table-sm table-hover table-responsive">
        <thead>
          <tr>
            <th scope="col">created_at</th>
            <th scope="col" v-for="title, index in aliasArray" :key="index">{{ title }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items, index) in main_data" :key="index">
            <td v-for="(item, index) in items" :key="index">
              <div v-if="index === 'created_at'"> {{ item }}</div>
              <div v-else v-for="(value, key) in item" :key="key">
                <p>
                  <span v-show="key === 'ep'">電度(ep)</span>
                  <span v-show="key === 'p'">功率(p)</span>
                  <span v-show="key === 'i'">電流(i)</span>
                  : {{ value }}
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="display: flex; justify-content: space-between;">
      <div>第 {{ data.current_page }} 頁 / 共 {{ data.last_page }} 頁</div>
      <div>顯示 {{ data.from }} 到 {{ data.to }} 筆 / 共 {{ data.total }} 筆</div>
    </div>
    <div style="display: flex; justify-content: center;">
      <div v-show="data.current_page !== 1">
        <button class=" btn btn-sm btn-outline-secondary" v-on:click="getBxData(data.first_page_url)">
          第 1 頁
        </button>
        <button class="btn btn-sm btn-outline-secondary" @click="getBxData(data.links[0].url)"
          v-html="'&laquo;'"></button>
      </div>

      <button class="btn btn-sm btn-outline-secondary" :class="{ active: item.active }"
        v-for="(item, index) in activeLinks" :key="index" @click="getBxData(item.url)" v-html="item.label"
        v-show="index !== 0 && item.label !== 'Next &raquo;'"></button>

      <div v-show="data.current_page !== data.last_page">
        <button class="btn btn-sm btn-outline-secondary" @click="getBxData(data.links[data.links.length - 1].url)"
          v-html="'&raquo;'"></button>
        <button class="btn btn-sm btn-outline-secondary" @click="getBxData(data.last_page_url)">最後一頁</button>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosMixins } from './mixins/axiosErrorMessage';

export default {
  props: ['regionMeter', 'requestDate'],
  mixins: [axiosMixins],
  data() {
    return {
      name: this.$store.getters.userInfo.name,
      data: {},
      bx_mac: '',
      base_url,
      request_date: '',
      main_data: [],
      aliasArray: [],
    }
  },
  computed: {
    activeLinks() {
      if (this.data.links) {
        const index = this.data.links.findIndex(item => item.active === true);
        if (index === -1) {
          return [];
        }
        const startIndex = Math.max(0, index - 3);
        const endIndex = Math.min(this.data.links.length, index + 3);
        return this.data.links.slice(startIndex, endIndex);
      } else {
        return []
      }
    }
  },
  watch: {
    request_date() {
      if (this.bx_mac) {
        this.getBxMainData();
      }
    },
    regionMeter() {
      this.getBxMainData();
    },
  },
  methods: {
    getBxMainData() {
      axios.get(base_url + "/api/bx/log/" + this.$props.regionMeter.bx_mac + "/" + this.request_date)
        .then((response) => {
          this.bxTableFormat(response);
        }).catch(error => this.axiosMessage(error));
    },
    getBxData(url) {
      axios.get(url)
        .then((response) => {
          this.bxTableFormat(response);
        }).catch(error => this.axiosMessage(error));
    },
    bxTableFormat(response) {
      this.main_data = [];
      this.data = response.data
      this.aliasArray = this.$props.regionMeter.bx_circuits.map(item => item.alias);
      this.data.data.forEach((item) => {
        let { created_at, i, p, ep } = item;
        const [year, month, date, hour, minute, second] = created_at.split(/[- :]/).map(Number);
        const local_date = new Date(Date.UTC(year, month - 1, date, hour, minute, second));
        const dateString = `${local_date.getFullYear()}-${(local_date.getMonth() + 1).toString().padStart(2, '0')}-${local_date.getDate().toString().padStart(2, '0')} ${local_date.getHours().toString().padStart(2, '0')}:${local_date.getMinutes().toString().padStart(2, '0')}:${local_date.getSeconds().toString().padStart(2, '0')}`;
        let values = { created_at: dateString };
        this.$props.regionMeter.bx_circuits.forEach((circuit) => {
          values[circuit.alias] = {
            ep: this.calculateSum(circuit.channels, JSON.parse(ep), "ep"),
            p: this.calculateSum(circuit.channels, JSON.parse(p), "p"),
            i: this.calculateSum(circuit.channels, JSON.parse(i), "i"),
          }
        });
        this.main_data.push(values);
      });
    },
    // 計算接線方法的總和
    calculateSum(channels, data, string) {
      const channelList = channels.split(',');
      let sum = 0;
      channelList.forEach(channel => {
        const key = string.toUpperCase() + channel[0] + (Number(channel[1]) - 1);
        sum += parseFloat(data[key]) * 1000000;
      });
      return sum / 1000000;
    }
  }
}
</script>
